import { render, staticRenderFns } from "./GrauDeInfracao.vue?vue&type=template&id=561e3f56&lang=pug&"
import script from "./GrauDeInfracao.vue?vue&type=script&lang=js&"
export * from "./GrauDeInfracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports